
import React from 'react';
import { ComponentNode } from '../types/template';
import DynamicSectionComponent from './DynamicSectionComponent';

interface BlogSectionComponentProps {
    component: ComponentNode;
    context?: {
        companyId?: string;
        templateId?: string;
        domain?: string;
        pageSlug?: string;
    };
}

const BlogSectionComponent: React.FC<BlogSectionComponentProps> = ({
    component,
    context,
}) => {
    return <DynamicSectionComponent component={component} context={context} />;
};

export default BlogSectionComponent;
